<template lang="html">
  <section class="section">
    <div class="container">

      <div class="columns is-centered">
        <div class="column is-12">
          <div class="columns is-vcentered">
            <div class="column">
              <h1 class="title is-size-3">Search</h1>
            </div>
            <div class="column is-narrow">
              <b-dropdown class="content" v-model="OptionPopular" aria-role="list" expanded>
                  <p
                class="is-dark-orange is-inline has-text-dark-orange"
                slot="trigger"
                role="button" expanded>
                <!-- Custom trigger -->
                        <template v-if="Recommended">
                            <span>Recommended</span>
                        </template>
                        <template v-if="isMostRecent">
                            <span>Most recent</span>
                        </template>
                        <template v-if="isPopular24h">
                            <span>Popular 24 hours</span>
                        </template>
                        <template v-if="isPopular1w">
                            <span>Popular 1 week</span>
                        </template>
                        <template v-if="isPopular1m">
                            <span>Popular 1 month</span>
                        </template>
                        <template v-if="isPopular1y">
                            <span>Popular 1 year</span>
                        </template>

                        <template v-else>
                            <span>Recommended</span>
                        </template>
                        <b-icon icon="menu-down"></b-icon>

                    </p>

                    <b-dropdown-item :value="1" aria-role="listitem">
                        Recommended
                    </b-dropdown-item>
                    <b-dropdown-item :value="2" aria-role="listitem">
                        Most recent
                    </b-dropdown-item>
                    <b-dropdown-item :value="3" aria-role="listitem">
                        Popular 24h
                    </b-dropdown-item>
                    <b-dropdown-item :value="4" aria-role="listitem">
                        Popular 1 week
                    </b-dropdown-item>
                    <b-dropdown-item :value="5" aria-role="listitem">
                        Popular 1 month
                    </b-dropdown-item>
                    <b-dropdown-item :value="6" aria-role="listitem">
                        Popular 1 year
                    </b-dropdown-item>

                </b-dropdown>
            </div>
          </div>

          <div class="content">

            <b-field type="is-dark-orange" >
            <b-input expanded placeholder="Search..."
            type="search"
                icon="magnify"
                icon-clickable
                @icon-click="search"></b-input>
            <p class="control">
                <b-button class="button is-dark-orange ">Search</b-button>
            </p>
        </b-field>

          </div>
        </div>
      </div>

      <b-tabs type="is-toggle" expanded>
        <b-tab-item>
          <template slot="header">
            <b-icon icon="wrench"></b-icon>
            <span>Crafts</span>
          </template>
          <crafts-tab/>
        </b-tab-item>

        <b-tab-item>
          <template slot="header">
            <b-icon icon="fountain-pen-tip"></b-icon>
              <span>Articles</span>
          </template>
          <articles-tab/>
        </b-tab-item>

        <b-tab-item>
          <template slot="header">
            <b-icon icon="folder-multiple-outline"></b-icon>
              <span>Projects</span>
          </template>
          <projects-tab/>
        </b-tab-item>

        <b-tab-item>
          <template slot="header">
            <b-icon icon="teach"></b-icon>
              <span>Teachers</span>
          </template>
          <teachers-tab/>
        </b-tab-item>

        <b-tab-item>
          <template slot="header">
            <b-icon icon="cart"></b-icon>
              <span>Stores</span>
          </template>
          <stores-tab/>
        </b-tab-item>
      </b-tabs>

    </div>
  </section>
</template>

<script>
import ArticlesTab from './tabs/ArticlesTab'
import CraftsTab from './tabs/CraftsTab'
import ProjectsTab from './tabs/ProjectsTab'
import StoresTab from './tabs/StoresTab'
import TeachersTab from './tabs/TeachersTab'
export default {
  components: {
    ArticlesTab,
    CraftsTab,
    TeachersTab,
    StoresTab,
    ProjectsTab
  },
  data () {
    return {
      isOpen: false,
      dates: []
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
